/**
 * Realtor Installation test case sections for Brokerage / Brokerage team member.
 * Content matches the test cases documented in:
 * - RealtorInstallationCreate-TestCases.md
 * - RealtorInstallationView-TestCases.md
 *
 * Components: RealtorAddInstallation, RealtorViewInstallation.
 */

export const REALTOR_INSTALLATION_CREATE_SECTIONS: {
  title: string;
  icon: string;
  items: { id: string; label: string }[];
}[] = [
  {
    title: "1. Realtor Add Installation (RealtorAddInstallation)",
    icon: "ri-add-circle-line",
    items: [
      { id: "RIC-V01", label: "Validation: installer, email, phone, billing/installation address, dates" },
      { id: "RIC-U01", label: "Brokerage team member / agent selection; office and cascade resets" },
      { id: "RIC-A01", label: "Address: same-as-billing, AddAddressFormModal, AddressAutocomplete" },
      { id: "RIC-S01", label: "SpecialFeeui: required/optional fees; tax and UnifiedInstallationCouponDiscount" },
      { id: "RIC-X01", label: "Submit: payload; success redirect; route brokerage / brokerageteammember" },
    ],
  },
  {
    title: "2. Post type, products & status (Brokerage)",
    icon: "ri-layout-grid-line",
    items: [
      { id: "RIC-P01", label: "PostTypeSignConfiguration and product selection" },
      { id: "RIC-P02", label: "InstallationStatusTracker: Draft → Payment → Finalized → …" },
      { id: "RIC-N01", label: "Notes (InstructionsCreateCard)" },
    ],
  },
];

export const REALTOR_INSTALLATION_VIEW_SECTIONS: {
  title: string;
  icon: string;
  items: { id: string; label: string }[];
}[] = [
  {
    title: "1. Realtor View Installation (RealtorViewInstallation)",
    icon: "ri-eye-line",
    items: [
      { id: "RIV-D01", label: "Load installation by ID; display address, post type, dates, products" },
      { id: "RIV-D02", label: "Special fees, tax, coupon, notes; InstallationStatusTracker steps" },
      { id: "RIV-A01", label: "Edit link and Back; route brokerage / brokerageteammember" },
    ],
  },
];
